import {PlatformManager} from '../abstract/PlatformManager';
import {SaveDataKeys} from '../SaveDataKeys';
import {InventoryData, Resource, ResourceName} from '../Inventory';
import {FBTournamentManager, IFBTournament} from './FBTournamentManager';

export class FacebookManager extends PlatformManager {

    public async setLoadingProgress(progress: number): Promise<void> {
        return FBInstant.setLoadingProgress(progress);
    }

    public startGameAsync(): Promise<void> {
        return FBInstant.startGameAsync();
    }

    public initializeAsync(): Promise<void> {
        return FBInstant.initializeAsync().then(() => {
            FBInstant.player
                .getDataAsync([SaveDataKeys.inventory]).then(async (result: any) => {
                    const inventoryData: InventoryData = result.inventory;
                    if (!inventoryData || inventoryData.length === 0) {
                        this._hasNoAdsPass = false;
                    } else {
                        inventoryData.forEach((resource: Resource) => {
                            if (resource.name === ResourceName.NoAdsPass && resource.amount > 0) {
                                this._hasNoAdsPass = true;
                            }
                        });
                    }

                    const currentTournament: IFBTournament = await FBTournamentManager.getInstance().getTournament();
                    const recentTournament: IFBTournament = await FBTournamentManager.getInstance().getRecentTournament();

                    if (currentTournament) {
                        FBTournamentManager.getInstance().isTournamentActive = true;
                    } else if (recentTournament) {
                        FBTournamentManager.getInstance()
                            .joinTournament(recentTournament.getID())
                            .finally(() => {
                                console.log('tournament created');
                            });
                    }
                }
            );
        });
    }

    public buyNoAdsPass(): void {
        this._hasNoAdsPass = true;
        // TODO: test this
        FBInstant.player
            .setDataAsync({
                inventory: {
                    amount: 0,
                    maxAmount: 1,
                    name: 'NoAdsPass'
                }
            });
    }

    public getUserLanguage(): string {
        return FBInstant.getLocale().split('_')[0].toUpperCase();
    }
}